import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import userContext from "./context";
import BankBg from "./bank2.jpg";

export default function Deposit() {
  const { users, setUsers } = useContext(userContext);
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();

  function handleDeposit() {
    // Find the specific user by email
    const userIndex = users.findIndex((u) => u.email === email);

    if (userIndex === -1) {
      alert("User not found! Please enter a valid registered email.");
      return;
    }
    
    // Validation for numbers
    if (isNaN(amount) || amount === "") {
      alert("Not a Number: Please enter a valid number");
      return;
    }
    if (Number(amount) <= 0) {
      alert("Negative Deposit: Please enter a positive number");
      return;
    }

    // Update the specific user's balance
    let updatedUsers = [...users];
    updatedUsers[userIndex].balance += Number(amount);
    setUsers(updatedUsers);

    alert(`Success: $${amount} deposited to ${updatedUsers[userIndex].name}'s account!`);
    setAmount("");
  }

  return (
    <div
      style={{
        backgroundImage: `url(${BankBg})`,
        backgroundSize: "cover",
        minHeight: "100vh",
        paddingTop: "50px",
      }}
    >
      <div className="container">
        {/* UI matches Withdraw page card styling */}
        <div
          className="card mx-auto shadow-lg"
          style={{
            maxWidth: "25rem",
            borderRadius: "15px",
            border: "none",
            backgroundColor: "rgba(255, 255, 255, 0.92)",
          }}
        >
          <div
            className="card-header text-center text-white"
            style={{
              backgroundColor: "#ffc107", 
              borderRadius: "15px 15px 0 0",
              padding: "20px",
            }}
          >
            <h3 className="mb-0 text-dark">Deposit Cash</h3>
          </div>

          <div className="card-body p-4">
            {/* User Identification Field */}
            <div className="mb-3 text-start">
              <label className="form-label fw-bold">Account Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter user email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Deposit Amount Field */}
            <div className="mb-4 text-start">
              <label className="form-label fw-bold">Amount to Deposit</label>
              <input
                type="input"
                className="form-control form-control-lg"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>

            {/* Submit Button */}
            <button
              disabled={!amount || !email}
              className="btn btn-warning btn-lg w-100 shadow-sm fw-bold mb-3"
              onClick={handleDeposit}
            >
              Deposit Now
            </button>

            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between mt-2">
              <button
                className="btn btn-sm btn-info"
                onClick={() => navigate("/alldata")}
              >
                View All Data
              </button>
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => navigate("/home")}
              >
                Back Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}